import React, { Fragment, useEffect, useState, useRef } from "react";
import FormSection from "components/sales/formSection/formSection";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import { FormGroup } from "react-bootstrap";
import TimePicker from "react-times";
import dateFormatReverse from "constants/dateformatReverse";
import "react-times/css/classic/default.css";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import useLatLng from "hooks/uselatlng/uselatlng";
import GoogleMapReact from "google-map-react";
import FileUpload from "components/sales/fileUpload/fileUpload";
import "pages/attendance/attendanceDetails/attStyle.css";
import { toast } from "react-toastify";
import CardSection from "components/sales/cardSection/cardSection";
import "./editmeetingform.css";
import DatePicker from "components/sales/datePicker/datePicker";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { Button } from "react-bootstrap";
import Checkbox from "components/sales/Input/checkbox/checkbox";
import Loader from "components/sales/Loader/loader";
import {
  SALES_SUB_SUBJECT_OPTIONS,
  RISK_CATEGORY_OPTIONS,
  CHURN_RISK_OPTIONS,
  isSalesMeetingAgenda,
  isLertAssessmentAgenda,
  isLertAssessmentFormReady,
  applyLertAssessmentFieldReset,
  EMPTY_PAYMENT_INPUT_ITERATION,
  getMeetingPayloadForSubject,
  getSubSubjectFromDraft,
} from '../meetingSalesSubSubject';

const isOtherClientCheckIn = (draft = {}) => {
  const siteId = Number(draft?.site_id);
  const otherSiteId = draft?.other_site_id;
  const hasOtherSiteId =
    otherSiteId !== null &&
    otherSiteId !== undefined &&
    otherSiteId !== "" &&
    Number(otherSiteId) !== 0;
  const checkinSiteId = Number(draft?.draft_data?.checkin_site_id);

  return (
    siteId === -1 ||
    checkinSiteId === -1 ||
    (siteId === 0 && !hasOtherSiteId)
  );
};

const EditMeetingForm = ({
  match,
  handleValue,
  saveAsDraft,
  pocList,
  documentUploadUrl,
  siteId,
  meetingById = null,
  teamId,
  corpClientList,
  getCorpPocList,
  corpClientPoc,
  viewMeeting,
  getInvoiceList,
  invoiceList,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  // setIsLoading,
  getCorpClientList,
  getBaOpportunityFromLeadx = () => {},
  opportunityLis = [],
  draftData = [],
  getSelfieData,
  siteFilters = [],
  getPocDataDropDown,
  pocDropdownData = [],
}) => {
  var currentDate = new Date();
  var day = currentDate.getDate();
  var month = currentDate.getMonth() + 1;
  var year = currentDate.getFullYear();
  day = day < 10 ? "0" + day : day;
  month = month < 10 ? "0" + month : month;
  var formattedDate = year + "-" + month + "-" + day;
  const inputs = {
    site_id: "",
    other_site_id: "",
    poc: "",
    others_email: "",
    scheduled_date: formattedDate,
    scheduled_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    subject: "",
    sub_subject: "",
    status: 1,
    body: "",
    client_id: "",
    client_category: 1,
    client: "NA",
    remark: "",
    attachment: "",
    paymentPicked: "",
    paymentMode: "",
    chequeRemark: "",
    opportunity: [],
    saleType: "",
    feedback_dropdown: "",
    client_reason: "",
    dashboard_check: "",
    dashboard_reason: "",
    training_check: "",
    training_reason: "",
    complaint_check: "",
    complaint_reason: "",
    whatsapp_check: "",
    whatsapp_reason: "",
    vms_check: "",
    vms_type: "",
    vms_others_reason: "",
    vms_duration: "",
    vms_usage: "",
    vms_paid: "",
    vms_paid_type: "",
    vms_maintenance_check: "",
    vms_maintenance_type: "",
    vms_maintenance_remark: "",
    crm_check: "",
    alignment_check: "",
    alignment_reason: "",
    car_check: "",
    car_reason: "",
    sampling_reason: "",
    sampling_check: "",
    kiosking_reason: "",
    kiosking_check: "",
    door_reason: "",
    door_check: "",
    waiting_time: "",
    poc_name: "",
    mobile_number: "",
    email_id: "",
    poc_remark: "",
    flat_cost: "",
    monthly_main_fees: "",
    facility_management: "",
    flat_count: "",
    locality: "",
    is_upselling_opportunity_exist: "",
    existing_upselling_opportunity: [],
    existing_upselling_opportunity_other: [],
    product_list: [],
    renewal_outcome: "",
    followup_date: "",
    followup_remark: "",
    cheque_pickup_type: "",
    other_remark: "",
    adsales_type: "",
    carnival_type: "",
    referral_discussed: "",
    did_client_refer_lead: "",
    referral_no_reason: "",
    client_reffer_no: "",
    type_of_referral: "",
    whatsapp_upload: "",
    for_hot_nego_sites: "",
    not_hot_nego_sites_reason: "",
    referral_shared_image: "",
    shared_referral_message: "",
    not_shared_referral_reason: "",
    got_video_testimonial: "",
    no_video_testimonial_reason: "",
    risk_category: "",
    risk_category_other: "",
    churn_risk: "",
  };

  const [inputIteration, setInputIteration] = useState([
    {
      invoice_number: "",
      cheque_trnx_no: "",
      cheque_trnx_date: "",
      bank: "",
      amount: "",
      document: "",
      invoice_name: "",
      tds_amount: "",
      document_type: "",
    },
  ]);
  const [formData, setData] = useState(inputs);
  const [pocsList, setPocsList] = useState([]);
  const [isFocus, setIsFocus] = useState(true);
  const [othersEmail, setOthersEmail] = useState("");
  const islatlng = useLatLng();
  const [selfie, setSelfie] = useState("");
  const [selfieUrl, setSelfieUrl] = useState("");
  const [checkSelfieUrl, setCheckSelfieUrl] = useState("");
  const [comments, setComments] = useState("");
  const [retake, setRetake] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    formatted_address: null,
    lat: 0,
    lng: 0,
  });
  const canvasRef = useRef(null);
  const [isAllow, setIsAllow] = useState(false);
  const [selectSiteId, setSelectSiteId] = useState(0);
  const [opportunity, setOpportunity] = useState([]);
  const [upsellingOpportunityExist, setUpsellingOpportunityExist] = useState(
    []
  );
  const [role, setRoleId] = useState("");
  const [renewalOutcome, setRenewalOutcome] = useState("");
  const [contractPoc, setContractPoc] = useState([]);
  const [documentType, setDocumentType] = useState("");
  const lertSubjectSyncRef = useRef("");

  const [productData, setProductData] = useState({
    product: "",
    quantity: "",
    unit_price: "",
    stage: "",
    sub_stage: "",
  });
  const productOptions = [
    { id: "Tags", name: "Tags" },
    { id: "LED 1*1", name: "LED 1*1" },
    { id: "Image Capturing (ANPR)", name: "Image Capturing (ANPR)" },
    { id: "ANPR - Gate Access", name: "ANPR - Gate Access" },
    { id: "Full Gate", name: "Full Gate" },
    { id: "Visitor Gate", name: "Visitor Gate" },
    { id: "Integration Gate", name: "Integration Gate" },
    { id: "Safety Addons", name: "Safety Addons" },
    { id: "Traffic Light", name: "Traffic Light" },
    { id: "Hooter", name: "Hooter" },
    { id: "Valet", name: "Valet" },
    { id: "Inventory Management", name: "Inventory Management" },
    { id: "Bookable Flow", name: "Bookable Flow" },
    { id: "Parking slot", name: "Parking slot" },
    { id: "Valet + Parking Slot", name: "Valet + Parking Slot" },
    { id: "LED 4*4", name: "LED 4*4" },
    { id: "Add New", name: "Add New" },
  ];

  const stageOptions = [
    { id: "Gate Crashing", name: "Gate Crashing" },
    { id: "Followup", name: "Followup" },
    { id: "Negotiation", name: "Negotiation" },
    { id: "Closure", name: "Closure" },
  ];

  const subStageOptions = [
    { id: "Cold", name: "Cold" },
    { id: "Warm", name: "Warm" },
    { id: "Hot", name: "Hot" },
  ];

  const renewalOutcomeList = [
    {
      id: "Cheque Picked ( AMC Renewed )",
      name: "Cheque Picked ( AMC Renewed )",
    },
    { id: "Agreement Shared", name: "Agreement Shared" },
    { id: "Asked to come later", name: "Asked to come later" },
  ];

  const chequePickupTypes = [
    { id: "Rental cheque pickup", name: "Rental cheque pickup" },
    { id: "AMC Cheque pickup", name: "AMC Cheque pickup" },
    { id: "Repair", name: "Repair" },
    { id: "Product - Tag", name: "Product - Tag" },
    { id: "Product - Safety Addon", name: "Product - Safety Addon" },
    {
      id: "New gate closure",
      name: "New gate closure (New Gate / integration / Visitor)",
    },
    { id: "Opex to capex", name: "Opex to capex" },
    {
      id: "Issue resolution - Payment",
      name: "Issue resolution - Payment (Ledger Reco.)",
    },
    { id: "Cheque not ready yet", name: "Cheque not ready yet" },
    {
      id: "Gate Crashing - Client not responding",
      name: "Gate Crashing - Client not responding",
    },
    { id: "PDC cheques", name: "PDC cheques" },
    { id: "Other", name: "Other - With Remarks" },
  ];

  const adSalesOptions = [
    {
      id: "Data Capturing - Society related activity",
      name: "Data Capturing - Society related activity",
    },
    { id: "Branding", name: "Branding" },
    { id: "New Vendor Visit", name: "New Vendor Visit" },
  ];

  const carnivalOptions = [
    {
      id: "Scheduling CARnival / Helpdesk",
      name: "Scheduling CARnival / Helpdesk",
    },
    {
      id: "Conducting CARnival / Helpdesk",
      name: "Conducting CARnival / Helpdesk / Brand Activity",
    },
    { id: "Conducting FIR", name: "Conducting FIR" },
  ];

  const [isAddingNewProduct, setIsAddingNewProduct] = useState(false);
  const [newProductName, setNewProductName] = useState("");

  const handleProductChange = (selectedProduct) => {
    console.log(selectedProduct);

    if (selectedProduct.id === "Add New") {
      setIsAddingNewProduct(true);
    } else {
      setIsAddingNewProduct(false);
      setProductData({
        ...productData,
        product: selectedProduct.id,
      });
    }
  };

  const handleStageChange = (selectedStage) => {
    console.log(selectedStage);

    setProductData({
      ...productData,
      stage: selectedStage.id,
      sub_stage: selectedStage.id === "Followup" ? subStageOptions[0].id : "",
    });
  };

  const handleAddProduct = () => {
    console.log(productData);

    const newProduct = {
      ...productData,
      product: isAddingNewProduct ? newProductName : productData.product,
      total_price: productData.quantity * productData.unit_price,
    };
    if (
      !newProduct.product ||
      !newProduct.quantity ||
      !newProduct.unit_price ||
      !newProduct.stage ||
      (newProduct.stage === "Followup" && !newProduct.sub_stage)
    ) {
      alert("Please fill in all fields.");
      return;
    }
    setData((prevFormData) => ({
      ...prevFormData,
      product_list: [...prevFormData.product_list, newProduct],
    }));

    // Reset product data
    setProductData({
      product: "",
      quantity: "",
      unit_price: "",
      stage: "",
      sub_stage: "",
    });

    setIsAddingNewProduct(false);
    setNewProductName("");
  };
  const handleNewProductNameChange = (val) => {
    setNewProductName(val);
    setData({
      ...formData,
      product: val,
    });
  };
  const handleDeleteProduct = (index) => {
    setData((prevFormData) => {
      const updatedProductList = prevFormData.product_list.filter(
        (_, i) => i !== index
      );
      return {
        ...prevFormData,
        product_list: updatedProductList,
      };
    });
  };
  const handleUpdateProduct = (index, key, value) => {
    console.log(index);
    console.log(value);
    console.log(key);
    const updatedProductList = formData.product_list.map((product, i) =>
      i === index
        ? {
            ...product,
            [key]: value,
            total_price:
              key === "quantity" || key === "unit_price"
                ? product.quantity * product.unit_price
                : product.total_price,
          }
        : product
    );
    console.log(updatedProductList);
    setData({ ...formData, product_list: updatedProductList });
  };
  const handleRenewalOutcomeChange = (selectedOutcome) => {
    setData({
      ...formData,
      renewal_outcome: selectedOutcome.id,
    });
  };
  const handleChequePickupChange = (selectedType) => {
    setData({
      ...formData,
      cheque_pickup_type: selectedType.id,
    });
  };

  const handleAdSalesChange = (selectedType) => {
    setData({
      ...formData,
      adsales_type: selectedType.id,
    });
  };

  const handleCarnivalChange = (selectedType) => {
    setData({
      ...formData,
      carnival_type: selectedType.id,
    });
  };

  useEffect(() => {
    const upsellingOpportunitytExist = [];
    if (upsellingOpportunityExist.length > 0) {
      upsellingOpportunityExist.map((val, index) => {
        upsellingOpportunitytExist[index] = val.name;
      });
      window.localStorage.upselling_oppor = JSON.stringify(
        upsellingOpportunitytExist
      );
    }
  }, [upsellingOpportunityExist]);

  const handleDateHide = () => {
    if (formData.scheduled_date) {
      setIsFocus(true);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${islatlng?.lat}, ${islatlng?.lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
        );
        if (
          response !== null &&
          response?.data !== null &&
          response?.data?.results?.length > 0 &&
          response?.data?.results[0]?.formatted_address !== null
        ) {
          setMapLocation({
            ...mapLocation,
            formatted_address: response?.data?.results[0]?.formatted_address,
          });
        }
      } catch {
        toast.error("Google Map API failure");
        return;
      }
    };
    if (
      islatlng?.lat !== undefined &&
      islatlng?.lng !== undefined &&
      islatlng?.lat !== 0 &&
      islatlng?.lng !== 0 &&
      islatlng?.lat !== null &&
      islatlng?.lng !== null
    ) {
      fetchData();
    }
  }, [islatlng]);

  const currentDateTimeFormat = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const isPM = hours >= 12;
    const ampm = isPM ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    if (selfie !== "" && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = selfie;

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = "10px Arial";
        ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
        const backgroundHeight = 80;
        ctx.fillRect(
          0,
          canvas.height - backgroundHeight,
          canvas.width,
          backgroundHeight
        );
        ctx.fillStyle = "white";
        const yBase = canvas.height - 70;
        ctx.fillText(
          `lat-long ( ${Number(islatlng?.lat)} , ${Number(islatlng?.lng)} )`,
          10,
          yBase
        );
        ctx.fillText(
          `Image taken at: ${currentDateTimeFormat()}`,
          10,
          yBase + 20
        );

        const maxWidth = canvas.width - 20;
        const lineHeight = 18;
        const address = `Address: ${mapLocation?.formatted_address}`;
        if (
          mapLocation?.formatted_address != null ||
          mapLocation?.formatted_address != undefined
        ) {
          wrapTextAddress(ctx, address, 10, yBase + 40, maxWidth, lineHeight);
        }

        (async () => {
          setIsLoading(true);
          const url = await documentUploadUrlPublic({
            base_64_file: canvas.toDataURL("image/png"),
          });
          if (url) {
            setCheckSelfieUrl(url);
          }
          setIsLoading(false);
        })();
      };
    }
  }, [selfie]);

  function wrapTextAddress(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = ctx.measureText(testLine).width;
      if (testWidth > maxWidth && i > 0) {
        ctx.fillText(line, x, y);
        line = words[i] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
  }

  useEffect(() => {
    delete window.localStorage.upselling_oppor;
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  useEffect(() => {
    (async () => {
      if (parseInt(selectSiteId) !== 0 && selectSiteId !== "") {
        await getBaOpportunityFromLeadx(selectSiteId);
      }
    })();
  }, [selectSiteId]);

  useEffect(() => {
    if (meetingById !== null) {
      if (meetingById?.poc?.length > 0) {
        const pocIds =
          meetingById?.poc?.length > 0 && meetingById.poc.map((ele) => ele.id);
        setData({
          ...formData,
          poc: pocIds ? pocIds : "",
        });
        setPocsList(meetingById?.poc);
      }
      setData({
        ...formData,
        subject: meetingById?.meeting?.subject,
        body: meetingById?.meeting?.body,
        scheduled_date:
          (meetingById?.meeting?.scheduled_date &&
            dateFormatReverse(meetingById?.meeting?.scheduled_date)) ||
          new Date(),
      });
      setIsFocus(true);
    }
  }, [meetingById]);

  const handleDateChange = (date, dateString) => {
    setData({ ...formData, scheduled_date: dateString });
  };
  const handleChequeDateChange = (date, dateString) => {
    setData({ ...formData, chequeDate: dateString });
  };

  const sanitizeFormDataForSubject = (data = {}, extras = {}) =>
    getMeetingPayloadForSubject(data, extras);

  const resetNonLertAssessmentState = () => {
    setInputIteration(EMPTY_PAYMENT_INPUT_ITERATION);
    setOpportunity([]);
    setUpsellingOpportunityExist([]);
  };

  const handleMeetingData = () => {
    console.log(contractPoc);
    if (isAllow) {
      alert(localization.locationPermission);
      return false;
    }
    const isLertAssessment = isLertAssessmentAgenda(formData?.subject);
    const isFormComplete = isLertAssessment
      ? isLertAssessmentFormReady(formData)
      : formData.body !== "";
    if (
      formData.site_id !== "" &&
      formData.subject !== "" &&
      isFormComplete &&
      isAllow === false
    ) {
      const upsellingOpportunity = [];
      opportunity.map((val, index) => {
        upsellingOpportunity[index] = val.name;
      });

      const upsellingOpportunitytExist = [];
      upsellingOpportunityExist.map((val, index) => {
        upsellingOpportunitytExist[index] = val.name;
      });

      const meetingExtras = {
        lat: draftData?.latitude,
        lng: draftData?.longitude,
        opportunity: isLertAssessmentAgenda(formData?.subject)
          ? []
          : upsellingOpportunity,
        existing_upselling_opportunity: isLertAssessmentAgenda(formData?.subject)
          ? []
          : upsellingOpportunitytExist,
        inputIteration: isLertAssessmentAgenda(formData?.subject)
          ? EMPTY_PAYMENT_INPUT_ITERATION
          : inputIteration,
        selfieUrl,
        contract_poc_data: contractPoc,
      };

      meetingById !== null && meetingById?.meeting?.id
        ? handleValue(
            sanitizeFormDataForSubject(formData, {
              ...meetingExtras,
              id: meetingById?.meeting?.id,
            })
          )
        : handleValue(sanitizeFormDataForSubject(formData, meetingExtras));
    } else handleValue(null);
  };

  const handleSaveDraftData = () => {
    if (formData.site_id !== "") {
      const upsellingOpportunity = [];
      opportunity.map((val, index) => {
        upsellingOpportunity[index] = val.name;
      });

      const upsellingOpportunitytExist = [];
      upsellingOpportunityExist.map((val, index) => {
        upsellingOpportunitytExist[index] = val.name;
      });

      if (formData?.subject !== "Payment Collection Meeting") {
        formData["paymentPicked"] = "";
        formData["saleType"] = "";
        formData["paymentMode"] = "";
        formData["attachment"] = "";
        formData["chequeRemark"] = "";
        setInputIteration([
          {
            invoice_number: "",
            cheque_trnx_no: "",
            cheque_trnx_date: "",
            bank: "",
            amount: "",
            document: "",
            invoice_name: "",
            tds_amount: "",
            document_type: "",
          },
        ]);
      }

      if (formData?.subject !== "Upselling") {
        setOpportunity([]);
      }

      if (formData?.subject !== "Other") {
        formData["remark"] = "";
      }

      if (!isSalesMeetingAgenda(formData?.subject)) {
        formData["sub_subject"] = "";
      }

      if (!isLertAssessmentAgenda(formData?.subject)) {
        formData["risk_category"] = "";
        formData["risk_category_other"] = "";
        formData["churn_risk"] = "";
      } else {
        resetNonLertAssessmentState();
      }

      const draftExtras = {
        lat: islatlng?.lat,
        lng: islatlng?.lng,
        opportunity: isLertAssessmentAgenda(formData?.subject)
          ? []
          : upsellingOpportunity,
        existing_upselling_opportunity: isLertAssessmentAgenda(
          formData?.subject
        )
          ? []
          : upsellingOpportunitytExist,
        inputIteration: isLertAssessmentAgenda(formData?.subject)
          ? EMPTY_PAYMENT_INPUT_ITERATION
          : inputIteration,
        selfieUrl,
        contract_poc_data: contractPoc,
      };

      meetingById !== null && meetingById?.meeting?.id
        ? handleValue(
            sanitizeFormDataForSubject(formData, {
              ...draftExtras,
              id: meetingById?.meeting?.id,
            })
          )
        : handleValue(sanitizeFormDataForSubject(formData, draftExtras));
    } else handleValue(null);
  };

  useEffect(() => {
    if (formData.site_id !== "") {
      handleSaveDraftData();
    }
  }, [formData]);

  useEffect(() => {
    if (!isLertAssessmentAgenda(formData?.subject)) {
      lertSubjectSyncRef.current = formData?.subject ?? "";
      return;
    }

    if (lertSubjectSyncRef.current === formData?.subject) {
      return;
    }

    lertSubjectSyncRef.current = formData?.subject ?? "";
    setData((prev) => applyLertAssessmentFieldReset(prev));
    resetNonLertAssessmentState();
  }, [formData?.subject]);

  useEffect(() => {
    const isLertAssessment = isLertAssessmentAgenda(formData?.subject);
    const isFormComplete = isLertAssessment
      ? isLertAssessmentFormReady(formData)
      : formData.body !== "";
    if (
      formData.site_id !== "" &&
      formData.subject !== "" &&
      isFormComplete
    ) {
      console.log(formData);
      handleMeetingData();
    }
  }, [formData, inputIteration, contractPoc]);

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, scheduled_time: `${hour}:${minute}` });
  }
  function renderMarkers(map, maps) {
    let marker = new maps.Marker({
      position: {
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      },
      map,
      title: "You are here!",
    });
  }

  const handleValues = (val, key, index) => {
    var flag = true;
    if (key === "invoice_number") {
      inputIteration.map((value, i) => {
        // console.log(value['invoice_number'] + ' ' + val.id);
        if (value["invoice_number"] && value["invoice_number"] === val.id) {
          toast.error(
            "This invoice is aleady selected. Please choose another."
          );
          flag = false;
          return false;
        }
      });
    }

    if (key === "document_type") {
      handleDocumentTypeChange(val);
    }
    const list = [...inputIteration];
    if (key === "invoice_number") {
      list[index][key] = flag == true ? val.id : "";
      list[index]["invoice_name"] = flag == true ? val.name : "";
    } else {
      list[index][key] = val;
    }

    // console.log(list);
    setInputIteration([...list]);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputIteration];
    list.splice(index, 1);
    setInputIteration(list);
  };

  const handleAddClick = () => {
    setInputIteration([
      ...inputIteration,
      {
        invoice_number: "",
        cheque_trnx_no: "",
        cheque_trnx_date: "",
        bank: "",
        amount: "",
        document: "",
        invoice_name: "",
        tds_amount: "",
        document_type: "",
      },
    ]);
  };

  // const getInvoicesAgainstSite = async (siteId) => {
  //     if(siteId != "" && siteId != undefined) {
  //          const invoices = getInvoiceList(siteId, documentType);
  //     }
  // }

  const applySearchKey = async (tranxNo, key, index) => {
    if (tranxNo && tranxNo != "") {
      const url = `${Config.brandActivation.getTransactionAmountFromUncliamed}?transaction_id=${tranxNo}`;
      const { data } = await axios.get(url);
      if (data && data.response.data) {
        var amount = "";
        if (data.response.data.resultSets && data.response.data.resultSets[0]) {
          amount = data.response.data.resultSets[0].transaction_amount;
          toast.success("Amount fetched successfully.");
        } else {
          toast.info("No transaction found.");
        }
        const list = [...inputIteration];
        list[index][key] = amount;
        setInputIteration([...list]);
      }
    }
  };

  const handleDocumentTypeChange = async (id) => {
    setIsLoading(true);
    await getInvoiceList(draftData?.other_site_id, id);
    setIsLoading(false);
  };

  useEffect(() => {
    if (draftData !== null && Object.keys(draftData).length > 0) {
      setSelectSiteId(draftData?.site_id);
      formData["site_id"] = draftData?.site_id;
      formData["other_site_id"] = draftData?.other_site_id;
      formData["scheduled_date"] = draftData?.scheduled_date;
      formData["scheduled_time"] = draftData?.scheduled_time;
      formData["subject"] = draftData?.subject;
      formData["sub_subject"] = getSubSubjectFromDraft(draftData);
      formData["body"] = draftData?.body;
      formData["paymentPicked"] = draftData?.cheque_picked;
      formData["saleType"] = draftData?.sales_type;
      formData["paymentMode"] = draftData?.payment_mode;
      formData["remark"] = draftData?.draft_data?.remark;
      formData["attachment"] = draftData?.draft_data?.attachment;
      formData["chequeRemark"] = draftData?.draft_data?.cheque_remark;
      formData["feedback_dropdown"] =
        draftData?.checkout_details?.feedback_dropdown;
      formData["client_reason"] = draftData?.checkout_details?.client_reason;
      formData["dashboard_check"] =
        draftData?.checkout_details?.dashboard_check;
      formData["dashboard_reason"] =
        draftData?.checkout_details?.dashboard_reason;
      formData["training_check"] = draftData?.checkout_details?.training_check;
      formData["training_reason"] =
        draftData?.checkout_details?.training_reason;
      formData["complaint_check"] =
        draftData?.checkout_details?.complaint_check;
      formData["complaint_reason"] =
        draftData?.checkout_details?.complaint_reason;
      formData["whatsapp_check"] = draftData?.checkout_details?.whatsapp_check;
      formData["whatsapp_reason"] =
        draftData?.checkout_details?.whatsapp_reason;
      formData["vms_check"] = draftData?.checkout_details?.vms_check;
      formData["vms_type"] = draftData?.checkout_details?.vms_type;
      formData["vms_others_reason"] =
        draftData?.checkout_details?.vms_others_reason;
      formData["vms_duration"] = draftData?.checkout_details?.vms_duration;
      formData["vms_usage"] = draftData?.checkout_details?.vms_usage;
      formData["vms_paid"] = draftData?.checkout_details?.vms_paid;
      formData["vms_paid_type"] = draftData?.checkout_details?.vms_paid_type;
      formData["vms_maintenance_check"] =
        draftData?.checkout_details?.vms_maintenance_check;
      formData["vms_maintenance_type"] =
        draftData?.checkout_details?.vms_maintenance_type;
      formData["vms_maintenance_remark"] =
        draftData?.checkout_details?.vms_maintenance_remark;
      formData["crm_check"] = draftData?.checkout_details?.crm_check;
      formData["alignment_check"] =
        draftData?.checkout_details?.alignment_check;
      formData["alignment_reason"] =
        draftData?.checkout_details?.alignment_reason;
      formData["car_check"] = draftData?.checkout_details?.car_check;
      formData["car_reason"] = draftData?.checkout_details?.car_reason;
      formData["sampling_reason"] =
        draftData?.checkout_details?.sampling_reason;
      formData["sampling_check"] = draftData?.checkout_details?.sampling_check;
      formData["kiosking_reason"] =
        draftData?.checkout_details?.kiosking_reason;
      formData["kiosking_check"] = draftData?.checkout_details?.kiosking_check;
      formData["door_reason"] = draftData?.checkout_details?.door_reason;
      formData["door_check"] = draftData?.checkout_details?.door_check;
      formData["waiting_time"] = draftData?.checkout_details?.waiting_time;
      formData["selfieUrl"] = draftData?.checkout_details?.selfieUrl;
      formData["poc_name"] = draftData?.checkout_details?.poc_name;
      formData["mobile_number"] = draftData?.checkout_details?.mobile_number;
      formData["email_id"] = draftData?.checkout_details?.email_id;
      formData["poc_remark"] = draftData?.checkout_details?.poc_remark;
      formData["flat_cost"] = draftData?.checkout_details?.flat_cost;
      formData["monthly_main_fees"] =
        draftData?.checkout_details?.monthly_main_fees;
      formData["facility_management"] =
        draftData?.checkout_details?.facility_management;
      formData["flat_count"] = draftData?.checkout_details?.flat_count;
      formData["locality"] = draftData?.checkout_details?.locality;
      formData["is_upselling_opportunity_exist"] =
        draftData?.checkout_details?.is_upselling_opportunity_exist;
      // formData['existing_upselling_opportunity'] = draftData?.checkout_details?.existing_upselling_opportunity;
      formData["existing_upselling_opportunity_other"] =
        draftData?.checkout_details?.existing_upselling_opportunity_other;

      formData["other_site"] = draftData?.other_site;
      formData["other_client_name"] = draftData?.other_client_name;
      formData["other_client_email"] = draftData?.other_client_email;
      formData["product_list"] = draftData?.product_list;
      formData["renewal_outcome"] =
        draftData?.checkout_details?.renewal_outcome;
      formData["followup_date"] = draftData?.checkout_details?.followup_date;
      formData["followup_remark"] =
        draftData?.checkout_details?.followup_remark;
      formData["cheque_pickup_type"] =
        draftData?.checkout_details?.cheque_pickup_type;
      formData["other_remark"] = draftData?.checkout_details?.other_remark;
      formData["adsales_type"] = draftData?.checkout_details?.adsales_type;
      formData["carnival_type"] = draftData?.checkout_details?.carnival_type;
      formData["referral_discussed"] =
        draftData?.checkout_details?.referral_discussed;
      formData["did_client_refer_lead"] =
        draftData?.checkout_details?.did_client_refer_lead;
      formData["referral_no_reason"] =
        draftData?.checkout_details?.referral_no_reason;
      formData["client_reffer_no"] =
        draftData?.checkout_details?.client_reffer_no;
      formData["type_of_referral"] =
        draftData?.checkout_details?.type_of_referral;
      formData["whatsapp_upload"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["for_hot_nego_sites"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["not_hot_nego_sites_reason"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["referral_shared_image"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["shared_referral_message"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["not_shared_referral_reason"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["got_video_testimonial"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["no_video_testimonial_reason"] =
        draftData?.checkout_details?.whatsapp_upload;
      formData["risk_category"] =
        draftData?.checkout_details?.risk_category ?? "";
      formData["risk_category_other"] =
        draftData?.checkout_details?.risk_category_other ?? "";
      formData["churn_risk"] = draftData?.checkout_details?.churn_risk ?? "";

      const loadedFormData = isLertAssessmentAgenda(formData.subject)
        ? applyLertAssessmentFieldReset({ ...formData })
        : { ...formData };

      setData(loadedFormData);
      if (isLertAssessmentAgenda(formData.subject)) {
        resetNonLertAssessmentState();
      } else {
        setInputIteration(
          draftData?.draft_data?.inputIteration !== undefined
            ? draftData?.draft_data?.inputIteration
            : inputIteration
        );
      }
      // setOpportunity(
      //     draftData?.draft_data?.opportunity !== undefined ?
      //     draftData?.draft_data?.opportunity : opportunity
      // )
    }
  }, [draftData]);

  useEffect(() => {
    setRoleId(localStorage.getItem("fusion-role"));
  }, []);

  useEffect(() => {
    if (checkSelfieUrl?.file_url !== undefined) {
      setSelfieUrl(checkSelfieUrl?.file_url);
    }
  }, [checkSelfieUrl]);

  // useEffect(() => {
  //   if(selectSiteId!=0){
  //     getInvoicesAgainstSite(selectSiteId);
  //   }
  // }, [selectSiteId])

  const handleReferral = (val) => {
    if (val === "No") {
      let list2 = { ...formData };
      list2["referral_discussed"] = val;
      list2["did_client_refer_lead"] = "";
      list2["client_reffer_no"] = "";
      list2["type_of_referral"] = "";
      list2["whatsapp_upload"] = "";
      setData(list2);
    }
  };

  const handleClientReferral = (val) => {
    if (val === "No") {
      let list2 = { ...formData };
      list2["did_client_refer_lead"] = val;
      list2["type_of_referral"] = "";
      list2["whatsapp_upload"] = "";
      setData(list2);
    }
  };

  const handleSetPoc = (val) => {
    if (Array.isArray(val)) {
      setContractPoc(val.map((obj) => obj.id));
    } else {
      setContractPoc([]);
    }
  };

  return (
    <>
      <CardSection title={localization.meetingDetails}>
        <div className="row">
          <div className="col-md-12">
            <div class="panel-heading messageBox">
              <div>
                Lat. : {draftData?.latitude}
                &nbsp; Long. : {draftData?.longitude}
              </div>
            </div>
          </div>

          {corpClientList && corpClientList.sites ? (
            <div className="col-md-6">
              <DropDownInput
                value={draftData?.other_client_name || draftData?.site_name}
                label={localization.clientName}
                required
                getIdValue={(val) => {
                  setData({
                    ...formData,
                    site_id: val.id,
                    other_site_id: draftData?.other_site_id,
                  });
                  setSelectSiteId(val.id);
                  // getInvoicesAgainstSite(val.id);
                }}
                errorMsg={localization.requiredName}
                isStarRequired={true}
                disabled
              />
            </div>
          ) : null}

          {isOtherClientCheckIn(draftData) && (
            <div className="col-md-6">
              <ConstantInput
                label={"Client Email"}
                errorMsg={
                  !formData?.other_client_email
                    ? localization.emailAddressRequired
                    : localization.emailError
                }
                type="email"
                required
                isStarRequired={true}
                regex={Regex.email.test(formData?.other_client_email || "")}
                value={formData?.other_client_email || ""}
                handleChange={(value) =>
                  setData({
                    ...formData,
                    other_client_email: value,
                  })
                }
              />
            </div>
          )}

          <div className="col-md-6">
            <FormGroup
              className={`date custom_date_picker ${
                isFocus ? "active-date" : ""
              }`}
            >
              <DatePickerInput
                value={formData?.scheduled_date}
                onChange={handleDateChange}
                onShow={() => setIsFocus(true)}
                onHide={handleDateHide}
                onClear={() => setIsFocus(false)}
                autoClose
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                required
                displayFormat="DD-MM-YYYY"
                returnFormat="YYYY-MM-DD"
                maxDate={new Date()}
                disabled
              />

              <label>
                {localization.selectDate}
                <span className="label-star" style={{ color: "red" }}>
                  {" "}
                  *{" "}
                </span>
              </label>
              {!isFocus && (
                <label className="error date_error">
                  {localization.isRequired}
                </label>
              )}
            </FormGroup>
          </div>
          <div className="col-md-6">
            <FormGroup>
              <TimePicker
                theme="classic"
                timeFormat="HH:MM"
                timeMode={24}
                time={formData?.scheduled_time}
                onTimeChange={onChange}
                disabled
              />
              <label>{localization.selectTime}</label>
              <label className="error date_error">
                {localization.isRequired}
              </label>
            </FormGroup>
          </div>

          <div className="col-md-6">
            {corpClientList && corpClientList.agenda ? (
              <DropDownInput
                value={formData?.subject !== null ? formData?.subject : ""}
                data={corpClientList?.agenda}
                label={localization.meetingAgenda}
                required
                errorMsg={localization.meetingAgenda}
                getIdValue={(val) => {
                  const nextSubject = val.id;
                  const isNextLertAssessment =
                    isLertAssessmentAgenda(nextSubject);

                  if (isNextLertAssessment) {
                    resetNonLertAssessmentState();
                    setData(
                      applyLertAssessmentFieldReset({
                        ...formData,
                        subject: nextSubject,
                        paymentPicked: "",
                        sub_subject: "",
                        risk_category: formData.risk_category,
                        risk_category_other: formData.risk_category_other,
                        churn_risk: formData.churn_risk,
                      })
                    );
                    return;
                  }

                  setData({
                    ...formData,
                    subject: nextSubject,
                    paymentPicked: "",
                    sub_subject: isSalesMeetingAgenda(nextSubject)
                      ? formData.sub_subject
                      : "",
                    risk_category: "",
                    risk_category_other: "",
                    churn_risk: "",
                  });
                }}
                isStarRequired={true}
              />
            ) : null}
          </div>

          {isSalesMeetingAgenda(formData.subject) && (
            <div className="col-md-6">
              <DropDownInput
                data={SALES_SUB_SUBJECT_OPTIONS}
                label={localization.subMeetingAgenda}
                getIdValue={(val) =>
                  setData({ ...formData, sub_subject: val?.id ?? "" })
                }
                value={formData?.sub_subject}
              />
            </div>
          )}

          {/* { (formData.subject === "Upselling") &&
        <div className='col-md-6' key="id7">
          <DropDownInput
              data={opportunityLis}
              selectedList={ draftData?.draft_data?.opportunity !== undefined ? draftData?.draft_data?.opportunity : '' }
              label={localization.opportunity}
              required={true}
              errorMsg={localization.opportunity}
              getIdValue={(val) => {
                  setOpportunity(val)
              }}
              isStarRequired={true}
              multipule={true}
          />
        </div>
      } */}
          {formData.subject === "Contract Renewal" && (
            <div className="row mt-3">
              <div className="col-md-12">
                <DropDownInput
                  data={renewalOutcomeList}
                  label="Meeting Outcome"
                  required={true}
                  errorMsg="Meeting Outcome is required"
                  getIdValue={(val) => {
                    handleRenewalOutcomeChange(val);
                  }}
                  isStarRequired={true}
                />
              </div>
              {formData.renewalOutcome === "Asked to come later" && (
                <>
                  <div className="col-md-12 mt-2">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Follow-up Date"
                      value={formData.followupDate}
                      isStarRequired={true}
                      required={true}
                      onChange={(e) =>
                        setData({ ...formData, followupDate: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Follow-up Remark"
                      value={formData.followupRemark}
                      isStarRequired={true}
                      required={true}
                      onChange={(e) =>
                        setData({ ...formData, followupRemark: e.target.value })
                      }
                    />
                  </div>
                </>
              )}
            </div>
          )}
          {formData.subject === "Ad-Sales" && (
            <div className="col-md-6">
              <DropDownInput
                data={adSalesOptions}
                label="Ad-Sales Type"
                getIdValue={handleAdSalesChange}
                value={formData.adsales_type}
                isStarRequired={true}
                required={true}
              />
            </div>
          )}
          {formData.subject === "Carnival Schedule" && (
            <div className="col-md-6">
              <DropDownInput
                data={carnivalOptions}
                label="Carnival Type"
                value={formData.carnival_type}
                getIdValue={handleCarnivalChange}
                isStarRequired={true}
                required={true}
              />
            </div>
          )}
          {formData && formData.subject === "Payment Collection Meeting" && (
            <div className="col-md-6">
              <DropDownInput
                data={chequePickupTypes}
                label="Cheque Pickup Type"
                value={formData.cheque_pickup_type}
                getIdValue={handleChequePickupChange}
                isStarRequired={true}
              />
            </div>
          )}
          <div className="col-md-6">
            {formData &&
              formData.subject === "Payment Collection Meeting" &&
              formData.cheque_pickup_type === "Other" && (
                <input
                  type="text"
                  className="form-control"
                  placeholder="Remark"
                  value={formData.other_remark}
                  onChange={(e) =>
                    setData({ ...formData, otherRemark: e.target.value })
                  }
                />
              )}
          </div>

          {/* <div className='row mb-3 mt-3'> */}

          {formData && formData.subject === "Payment Collection Meeting" && (
            <div className="col-md-6">
              <DropDownInput
                data={[
                  { id: "Yes", name: "Yes" },
                  { id: "No", name: "No" },
                ]}
                label={localization.paymentPicked}
                required
                value={
                  formData?.paymentPicked !== null
                    ? formData?.paymentPicked
                    : ""
                }
                errorMsg={localization.paymentPicked}
                getIdValue={(val) => {
                  setData({
                    ...formData,
                    paymentPicked: val.id,
                  });
                }}
                isStarRequired={true}
              />
            </div>
          )}

          {/* {console.log(formData)} */}
          {formData && formData.paymentPicked === "Yes" ? (
            <>
              <div className="col-md-6">
                <DropDownInput
                  label={localization.saleTypeHeading}
                  data={[
                    {
                      id: "Collection against invoice",
                      name: "Collection against invoice",
                    },
                    { id: "New Sale", name: "New Sale" },
                  ]}
                  required
                  value={formData?.saleType !== null ? formData?.saleType : ""}
                  errorMsg={localization.saleTypeHeading}
                  getIdValue={(val) => {
                    setData({
                      ...formData,
                      saleType: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              </div>
            </>
          ) : null}

          {formData &&
          formData.paymentPicked === "Yes" &&
          formData.saleType != "" ? (
            <>
              <div className="col-md-6">
                <DropDownInput
                  label={localization.paymentMode}
                  data={[
                    { id: "Cash", name: "Cash" },
                    { id: "Cheque", name: "Cheque" },
                    { id: "NEFT", name: "NEFT" },
                    { id: "IMPS", name: "IMPS" },
                    { id: "RTGS", name: "RTGS" },
                    { id: "UPI", name: "UPI" },
                    { id: "NACH", name: "NACH" },
                    { id: "PDC_CHEQUE", name: "PDC_CHEQUE" },
                  ]}
                  required
                  errorMsg={localization.paymentMode}
                  getIdValue={(val) => {
                    setData({
                      ...formData,
                      paymentMode: val.id,
                    });
                  }}
                  value={
                    formData?.paymentMode !== null ? formData?.paymentMode : ""
                  }
                  isStarRequired={true}
                />
              </div>
            </>
          ) : null}
          {formData && formData.paymentPicked === "No" && (
            <div className="col-md-6">
              <ConstantInput
                value={
                  formData?.chequeRemark !== null ? formData?.chequeRemark : ""
                }
                label={localization.chequeReason}
                errorMsg={localization.chequeReason}
                type="text"
                required
                isStarRequired={true}
                handleChange={(value) =>
                  setData({ ...formData, chequeRemark: value })
                }
              />
            </div>
          )}
          <div className="col-md-6">
            {formData && formData.subject === "Other" && (
              <ConstantInput
                value={formData?.remark !== null ? formData?.remark : ""}
                label={localization.enterSubject}
                errorMsg={localization.enterSubject}
                type="text"
                required
                isStarRequired={true}
                handleChange={(value) =>
                  setData({ ...formData, remark: value })
                }
              />
            )}
          </div>
          {/* </div> */}
          {formData &&
          formData.paymentPicked === "Yes" &&
          formData.paymentMode != "" ? (
            <>
              {inputIteration.map((x, i) => {
                return (
                  <div className="col-md-12 row dd-cl">
                    {formData.saleType != "" &&
                      formData.saleType != "New Sale" && (
                        <>
                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "INVOICE", name: "INVOICE" },
                                { id: "DEBITNOTE", name: "DEBITNOTE" },
                              ]}
                              label="Document Type"
                              required
                              getIdValue={(val) => {
                                if (val && val.id) {
                                  handleValues(val.id, "document_type", i);
                                } else if (val && val.value) {
                                  handleValues(val.value, "document_type", i);
                                }
                              }}
                              value={documentType || ""}
                              isStarRequired={true}
                            />

                            {/* <DropDownInput
                            data={[
                              { id: "RegularisationHalfDay", name: "Half Day" },
                              { id: "RegularisationFullDay", name: "Full Day" },
                              { id: "Overtime", name: "Overtime" },
                            ]}
                            label={"Day Type"}
                            required
                            getIdValue={(val) => {
                              setFormData({ ...formData, day_type: val.id });
                            }}
                            isStarRequired={true}
                          /> */}
                          </div>
                          <div className="col-md-6">
                            <DropDownInput
                              data={invoiceList}
                              label={"Document Number"}
                              required
                              errorMsg={localization.invoice}
                              getIdValue={(val) => {
                                handleValues(val, "invoice_number", i);
                              }}
                              value={
                                !x?.invoice_number
                                  ? ""
                                  : invoiceList.find((item) => item.id === x.invoice_number)?.name || ""
                              }
                              isStarRequired={true}
                            />
                          </div>
                        </>
                      )}

                    <div className="col-md-6 d-inline-flex">
                      <ConstantInput
                        label={
                          formData.paymentMode === "Cheque"
                            ? localization.chequeNo
                            : localization.trnxNo
                        }
                        errorMsg={localization.chequeNo}
                        type="text"
                        required
                        value={
                          x?.cheque_trnx_no !== null ? x?.cheque_trnx_no : ""
                        }
                        isStarRequired={true}
                        handleChange={(value) =>
                          handleValues(value, "cheque_trnx_no", i)
                        }
                      />
                      {formData.paymentMode != "Cheque" &&
                        formData.paymentMode != "Cash" && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-primary colorBox borderColorBox"
                              onClick={() =>
                                applySearchKey(x.cheque_trnx_no, "amount", i)
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-search"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                              </svg>
                            </button>
                          </div>
                        )}
                    </div>

                    <div className="col-md-6">
                      <ConstantInput
                        value={x?.amount !== null ? x?.amount : ""}
                        label={
                          formData.paymentMode === "Cheque"
                            ? localization.chequeAmt
                            : localization.trnxAmt
                        }
                        errorMsg={localization.chequeAmt}
                        type="number"
                        required
                        isStarRequired={true}
                        handleChange={(value) =>
                          handleValues(value, "amount", i)
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <ConstantInput
                        value={x?.tds_amount !== null ? x?.tds_amount : ""}
                        label={localization.tdsAmount}
                        errorMsg={localization.tdsAmount}
                        type="number"
                        required
                        isStarRequired={true}
                        handleChange={(value) =>
                          handleValues(value, "tds_amount", i)
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <DropDownInput
                        data={[
                          {
                            id: "HDFC",
                            name: "HDFC",
                          },
                          {
                            id: "IDFC",
                            name: "IDFC",
                          },
                          {
                            id: "ICICI",
                            name: "ICICI",
                          },
                          {
                            id: "IDBI",
                            name: "IDBI",
                          },
                          {
                            id: "STANDARD_CHARTERED",
                            name: "STANDARD_CHARTERED",
                          },
                        ]}
                        label={localization.bankName}
                        required
                        value={x?.bank !== null ? x?.bank : ""}
                        errorMsg={localization.bankName}
                        getIdValue={(val) => {
                          handleValues(val.id, "bank", i);
                        }}
                        isStarRequired={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormGroup
                        className={`date custom_date_picker ${
                          isFocus ? "active-date" : ""
                        }`}
                      >
                        <DatePicker
                          handleChange={(val) =>
                            handleValues(val, "cheque_trnx_date", i)
                          }
                          label={localization.transactionDate}
                          required={false}
                          value={
                            x?.cheque_trnx_date !== null
                              ? x?.cheque_trnx_date
                              : ""
                          }
                        />
                      </FormGroup>
                    </div>

                    <div
                      className="col-md-4 "
                      key={i + 1}
                      style={{ wordBreak: "break-all" }}
                    >
                      <FileUpload
                        id={`document${i}`}
                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        required
                        isStarRequired={true}
                        errorMsg={localization.document}
                        prefilledFilename={
                          x?.document !== null ? x?.document : ""
                        }
                        onChange={(val) => handleValues(val, "document", i)}
                      >
                        <span className="btn btn-transparent">
                          {localization.document}
                        </span>
                      </FileUpload>
                    </div>
                    <div className="col-md-3 col-sm-12 d-flex">
                      {inputIteration.length !== 1 && (
                        <div className="col-md-2 col-sm-5">
                          <button
                            onClick={() => handleRemoveClick(i)}
                            className="mr10 btn btn-sm btn-danger"
                          >
                            Remove
                          </button>
                        </div>
                      )}
                      {inputIteration.length - 1 === i && (
                        <div className="col-md-2 col-sm-5">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleAddClick}
                          >
                            Add
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          ) : null}

          {/* </div>
  )}
          
      </div> */}

          <div className="col-md-12">
            <TextAreaInput
              inputValue={formData?.body !== null ? formData?.body : ""}
              className={`${
                !formData.body && "empty"
              } inline-css scrollbar-styling`}
              rows={4}
              type="text"
              label={localization.meetingDescription}
              required
              isStarRequired={true}
              errorMsg={localization.isRequired}
              handleChange={(e) =>
                setData({ ...formData, body: e.target.value })
              }
            />
          </div>
          {!isLertAssessmentAgenda(formData.subject) && (
          <div className="col-md-6 col-sm-12">
            <FileUpload
              id="attactment"
              accept=".pdf,.png,.jpg,.jpeg,.doc"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setData({ ...formData, attachment: val })}
              prefilledFilename={
                formData?.attachment !== null ? formData?.attachment : ""
              }
            >
              <span className="btn btn-transparent">
                {localization.uploadMultiAttachment}
              </span>
            </FileUpload>
          </div>
          )}
          <br />
        </div>
      </CardSection>
      <br></br>
      {(parseInt(role) === 14 || parseInt(role) === 15) && (
        <>
          {formData && formData.subject === "Sales" && (
            <CardSection title="Product Details">
              <Loader isLoading={false} />
              <div className="card-body bg-white">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <DropDownInput
                      data={productOptions}
                      label="Select Product"
                      value={productData.product}
                      getIdValue={(val) => handleProductChange(val)}
                    />
                    {isAddingNewProduct && (
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="New Product"
                        value={newProductName}
                        onChange={(e) =>
                          handleNewProductNameChange(e.target.value)
                        }
                      />
                    )}
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Quantity"
                      value={productData.quantity}
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          quantity: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Unit Price (including GST)"
                      value={productData.unit_price}
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          unit_price: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <DropDownInput
                      data={stageOptions}
                      label="Select Stage"
                      value={productData.stage}
                      getIdValue={(val) => handleStageChange(val)}
                    />
                  </div>
                  {productData.stage === "Followup" && (
                    <div className="col-md-4">
                      <DropDownInput
                        data={subStageOptions}
                        label="Select SubStage"
                        value={productData.sub_stage}
                        getIdValue={(val) =>
                          setProductData({ ...productData, sub_stage: val.id })
                        }
                      />
                    </div>
                  )}
                </div>
                <button
                  className="btn btn-success mb-3"
                  onClick={handleAddProduct}
                >
                  Add
                </button>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th>Product</th>
                      <th>Stage</th>
                      <th>SubStage</th>
                      <th>Quantity</th>
                      <th>Price per unit</th>
                      <th>Total</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.product_list &&
                      formData.product_list.map((product, index) => (
                        <tr key={index}>
                          <td>{product.product}</td>
                          <td>
                            <DropDownInput
                              data={stageOptions}
                              label=""
                              value={product.stage}
                              getIdValue={(val) =>
                                handleUpdateProduct(index, "stage", val.id)
                              }
                            />
                          </td>
                          <td>
                            {product.stage === "Followup" && (
                              <DropDownInput
                                data={subStageOptions}
                                label=""
                                value={product.sub_stage}
                                getIdValue={(val) =>
                                  handleUpdateProduct(
                                    index,
                                    "sub_stage",
                                    val.id
                                  )
                                }
                              />
                            )}
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={product.quantity}
                              onChange={(e) =>
                                handleUpdateProduct(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={product.unit_price}
                              onChange={(e) =>
                                handleUpdateProduct(
                                  index,
                                  "unit_price",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>{product.quantity * product.unit_price}</td>
                          <td>
                            <button
                              className="btn btn-danger mr-2"
                              onClick={() => handleDeleteProduct(index)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </CardSection>
          )}
          <CardSection title={localization.checkoutDetails}>
            <Loader isLoading={isLoading} />
            <div className="card-body bg-white">
              <div className="user">
                <div className="form-group row">
                  <div className="col-sm-12 col-md-12 mb-5 mt-1 float-field">
                    <canvas
                      ref={canvasRef}
                      width="400"
                      height="200"
                      style={{
                        display: "none",
                        border: "1px solid black",
                        marginTop: "20px",
                      }}
                    ></canvas>
                    {selfieUrl !== "" ? (
                      <>
                        <img
                          src={`${selfieUrl}`}
                          alt={""}
                          style={{ marginLeft: "34%" }}
                        />
                        <div className="container mt-4">
                          <Button
                            className="btn-sm"
                            style={{ marginLeft: "46%" }}
                            onClick={() => {
                              setRetake(true);
                              setSelfieUrl("");
                              setSelfie("");
                            }}
                          >
                            {"Retake"}
                          </Button>
                        </div>
                      </>
                    ) : (
                      retake && (
                        <Camera
                          idealFacingMode={"user"}
                          idealResolution={{ width: 400, height: 200 }}
                          onTakePhoto={(dataUri) => {
                            setIsLoading(true);
                            setSelfie(dataUri);
                            setRetake(false);
                            setIsLoading(false);
                          }}
                        />
                      )
                    )}
                  </div>
                  <div className="col-md-12 ">
                    <CardSection title={localization.pocTitle}>
                      <div className="card-body bg-white">
                        <div className="user">
                          {!draftData?.site_id && draftData?.site_id == 0 && (
                            <div className="form-group row">
                              <div className="col-md-6">
                                <ConstantInput
                                  label={"Meeting Person Name"}
                                  errorMsg={localization.isRequired}
                                  type="text"
                                  required
                                  value={formData?.poc_name || ""}
                                  isStarRequired={true}
                                  handleChange={(value) =>
                                    setData({ ...formData, poc_name: value })
                                  }
                                />

                                <ConstantInput
                                  label={"POC Mobile Number"}
                                  errorMsg={localization.isRequired}
                                  type="number"
                                  value={formData?.mobile_number || ""}
                                  handleChange={(value) =>
                                    setData({
                                      ...formData,
                                      mobile_number: value,
                                    })
                                  }
                                  tenDigitsValidation={true}
                                />
                              </div>
                              <div className="col-md-6">
                                <ConstantInput
                                  label={"POC Email Id"}
                                  errorMsg={localization.isRequired}
                                  type="email"
                                  value={formData?.email_id || ""}
                                  handleChange={(value) =>
                                    setData({ ...formData, email_id: value })
                                  }
                                />
                                <TextAreaInput
                                  inputValue={formData?.poc_remark || ""}
                                  className={`${
                                    !formData.poc_remark && "empty"
                                  } inline-css scrollbar-styling`}
                                  rows={4}
                                  type="text"
                                  label={localization.pocRemark}
                                  errorMsg={localization.isRequired}
                                  handleChange={(e) =>
                                    setData({
                                      ...formData,
                                      poc_remark: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          )}

                          <>
                            {draftData?.site_id !== 0 && (
                              <div className="form-group row">
                                <div className="col-md-12">
                                  <DropDownInput
                                    data={draftData?.contract_poc_dropdown}
                                    label={"Contract POC"}
                                    required
                                    getIdValue={(val) => {
                                      handleSetPoc(val);
                                    }}
                                    errorMsg={"Contract POC is required"}
                                    isStarRequired={true}
                                    multipule={true}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        </div>
                      </div>
                    </CardSection>
                  </div>
                  {isLertAssessmentAgenda(formData.subject) && (
                    <>
                      <div className="col-md-6">
                        <DropDownInput
                          data={RISK_CATEGORY_OPTIONS}
                          label="Risk Category"
                          required
                          value={formData?.risk_category || ""}
                          errorMsg="Risk Category is required"
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              risk_category: val?.id ?? "",
                              risk_category_other:
                                val?.id === "Other"
                                  ? formData.risk_category_other
                                  : "",
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <DropDownInput
                          data={CHURN_RISK_OPTIONS}
                          label="Churn Risk"
                          required
                          value={formData?.churn_risk || ""}
                          errorMsg="Churn Risk is required"
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              churn_risk: val?.id ?? "",
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.risk_category === "Other" && (
                        <div className="col-md-12">
                          <TextAreaInput
                            inputValue={formData?.risk_category_other || ""}
                            className={`${
                              !formData.risk_category_other && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label="Risk Category Details"
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                risk_category_other: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                    </>
                  )}
                  {!isLertAssessmentAgenda(formData.subject) && (
                  <>
                  {/* design change start  */}
                  <div className="col-md-6">
                    <DropDownInput
                      data={[
                        { id: "Yes", name: "Yes" },
                        { id: "No", name: "No" },
                      ]}
                      label={"Referral discussed during the meeting"}
                      required
                      value={
                        formData?.referral_discussed !== null
                          ? formData?.referral_discussed
                          : ""
                      }
                      errorMsg={localization.isRequired}
                      getIdValue={(val) => {
                        setData({
                          ...formData,
                          referral_discussed: val.id,
                        });
                        handleReferral(val.id);
                      }}
                      isStarRequired={true}
                    />
                  </div>

                  {formData?.referral_discussed === "Yes" && (
                    <>
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Did client refer any lead"}
                          required
                          value={
                            formData?.did_client_refer_lead !== null
                              ? formData?.did_client_refer_lead
                              : ""
                          }
                          errorMsg={localization.isRequired}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              did_client_refer_lead: val.id,
                            });
                            handleClientReferral(val.id);
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.did_client_refer_lead === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.client_reffer_no !== null
                                ? formData?.client_reffer_no
                                : ""
                            }
                            className={`${
                              !formData.client_reffer_no && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                client_reffer_no: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                      {formData?.did_client_refer_lead === "Yes" && (
                        <>
                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                {
                                  id: "Contact details shared",
                                  name: "Contact details shared",
                                },
                                {
                                  id: "Whatsapp message circulated",
                                  name: "Whatsapp message circulated",
                                },
                              ]}
                              label={"Type of referral"}
                              required
                              value={
                                formData?.type_of_referral !== null
                                  ? formData?.type_of_referral
                                  : ""
                              }
                              errorMsg={localization.isRequired}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  type_of_referral: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.type_of_referral ===
                            "Whatsapp message circulated" && (
                            <div className="col-md-6">
                              <FileUpload
                                id={"x-max-whatsapp"}
                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                documentUploadUrl={documentUploadUrlPublic}
                                documentUrlData={documentUrlDataPublic}
                                required
                                isStarRequired={true}
                                errorMsg={localization.document}
                                prefilledFilename={``}
                                onChange={(val) =>
                                  setData({
                                    ...formData,
                                    whatsapp_upload: val,
                                  })
                                }
                              >
                                <span className="btn btn-transparent">
                                  {localization.document}
                                </span>
                              </FileUpload>
                            </div>
                          )}
                          {formData?.type_of_referral ===
                            "Contact details shared" && (
                            <div
                              className="col-md-12 md-3"
                              style={{ marginBlock: "inherit" }}
                            >
                              <span class="red">
                                Please fill referral details in LeadX
                              </span>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {formData?.referral_discussed === "No" && (
                    <div className="col-md-6">
                      <TextAreaInput
                        inputValue={
                          formData?.referral_no_reason !== null
                            ? formData?.referral_no_reason
                            : ""
                        }
                        className={`${
                          !formData.referral_no_reason && "empty"
                        } inline-css scrollbar-styling`}
                        rows={4}
                        type="text"
                        label={localization.reason}
                        required
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        handleChange={(e) =>
                          setData({
                            ...formData,
                            referral_no_reason: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}

                  {draftData?.site_id != 0 && (
                    <>
                      <div className="col-md-6 ">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Feedback/Rating taken from the client."}
                          required
                          value={
                            formData?.feedback_dropdown !== null
                              ? formData?.feedback_dropdown
                              : ""
                          }
                          errorMsg={localization.isRequired}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              feedback_dropdown: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.feedback_dropdown === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.client_reason !== null
                                ? formData?.client_reason
                                : ""
                            }
                            className={`${
                              !formData.client_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                client_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}

                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Dashboard training given to the POC."}
                          required
                          value={
                            formData?.dashboard_check !== null
                              ? formData?.dashboard_check
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              dashboard_check: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.dashboard_check === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.dashboard_reason !== null
                                ? formData?.dashboard_reason
                                : ""
                            }
                            className={`${
                              !formData.dashboard_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                dashboard_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}

                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Test Ticket Raised."}
                          required
                          value={
                            formData?.training_check !== null
                              ? formData?.training_check
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              training_check: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.training_check === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.training_reason !== null
                                ? formData?.training_reason
                                : ""
                            }
                            className={`${
                              !formData.training_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                training_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}

                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Open Complaints Discussed."}
                          required
                          value={
                            formData?.complaint_check !== null
                              ? formData?.complaint_check
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              complaint_check: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.complaint_check === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.complaint_reason !== null
                                ? formData?.complaint_reason
                                : ""
                            }
                            className={`${
                              !formData.complaint_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                complaint_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}

                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Whatsapp group deletion."}
                          required
                          value={
                            formData?.whatsapp_check !== null
                              ? formData?.whatsapp_check
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              whatsapp_check: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.whatsapp_check === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.whatsapp_reason !== null
                                ? formData?.whatsapp_reason
                                : ""
                            }
                            className={`${
                              !formData.whatsapp_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                whatsapp_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}

                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Is property using any VMS?."}
                          required
                          value={
                            formData?.vms_check !== null
                              ? formData?.vms_check
                              : ""
                          }
                          errorMsg={localization.isRequired}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              vms_check: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.vms_check === "Yes" && (
                        <>
                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "MYGATE", name: "MYGATE" },
                                { id: "NBH", name: "NBH" },
                                { id: "ADDA", name: "ADDA" },
                                { id: "I-Society", name: "I-Society" },
                                { id: "Others", name: "Others" },
                              ]}
                              label={"VMS Type"}
                              required
                              value={
                                formData?.vms_type !== null
                                  ? formData?.vms_type
                                  : ""
                              }
                              errorMsg={localization.isRequired}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  vms_type: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.vms_type === "Others" && (
                            <div className="col-md-12">
                              <TextAreaInput
                                inputValue={
                                  formData?.vms_others_reason !== null
                                    ? formData?.vms_others_reason
                                    : ""
                                }
                                className={`${
                                  !formData.vms_others_reason && "empty"
                                } inline-css scrollbar-styling`}
                                rows={4}
                                type="text"
                                label={"Remark"}
                                required
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(e) =>
                                  setData({
                                    ...formData,
                                    vms_others_reason: e.target.value,
                                  })
                                }
                              />
                            </div>
                          )}

                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "0-3 months", name: "0-3 months" },
                                { id: "3-6 months", name: "3-6 months" },
                                { id: "6-12 months", name: "6-12 months" },
                                {
                                  id: "More than a year",
                                  name: "More than a year",
                                },
                              ]}
                              label={"VMS duration in society"}
                              required
                              value={
                                formData?.vms_duration !== null
                                  ? formData?.vms_duration
                                  : ""
                              }
                              errorMsg={localization.isRequired}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  vms_duration: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>

                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                {
                                  id: "Heavy ( Complaints / Bills / Visitors)",
                                  name: "Heavy ( Complaints / Bills / Visitors)",
                                },
                                {
                                  id: "Moderate ( Complaints /Visitors)",
                                  name: "Moderate ( Complaints /Visitors)",
                                },
                                {
                                  id: "Low ( Only visitors )",
                                  name: "Low ( Only visitors )",
                                },
                              ]}
                              label={"Type of usage"}
                              required
                              value={
                                formData?.vms_usage !== null
                                  ? formData?.vms_usage
                                  : ""
                              }
                              errorMsg={localization.isRequired}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  vms_usage: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>

                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "Yes", name: "Yes" },
                                { id: "No", name: "No" },
                              ]}
                              label={"Is VMS paid?"}
                              required
                              value={
                                formData?.vms_paid !== null
                                  ? formData?.vms_paid
                                  : ""
                              }
                              errorMsg={localization.isRequired}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  vms_paid: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.vms_paid === "Yes" && (
                            <div className="col-md-6">
                              <DropDownInput
                                data={[
                                  {
                                    id: "upto 1k monthly",
                                    name: "upto 1k monthly",
                                  },
                                  {
                                    id: "upto 2k monthly",
                                    name: "upto 2k monthly",
                                  },
                                  {
                                    id: "upto 3k monthly",
                                    name: "upto 3k monthly",
                                  },
                                  {
                                    id: "3k-5k monthly",
                                    name: "3k-5k monthly",
                                  },
                                  {
                                    id: "more than 5k monthly",
                                    name: "more than 5k monthly",
                                  },
                                ]}
                                label={"Vms Payment Duration"}
                                required
                                value={
                                  formData?.vms_paid_type !== null
                                    ? formData?.vms_paid_type
                                    : ""
                                }
                                errorMsg={localization.paymentPicked}
                                getIdValue={(val) => {
                                  setData({
                                    ...formData,
                                    vms_paid_type: val.id,
                                  });
                                }}
                                isStarRequired={true}
                              />
                            </div>
                          )}
                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "Yes", name: "Yes" },
                                { id: "No", name: "No" },
                              ]}
                              label={
                                "Application used for paying maintenance dues?"
                              }
                              required
                              value={
                                formData?.vms_maintenance_check !== null
                                  ? formData?.vms_maintenance_check
                                  : ""
                              }
                              errorMsg={localization.paymentPicked}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  vms_maintenance_check: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>

                          {formData?.vms_maintenance_check === "Yes" && (
                            <>
                              <div className="col-md-6">
                                <DropDownInput
                                  data={[
                                    { id: "Paytm", name: "Paytm" },
                                    { id: "Gpay", name: "Gpay" },
                                    { id: "PhonePay", name: "PhonePay" },
                                    { id: "Others", name: "Others" },
                                  ]}
                                  label={"Vms Payment Type"}
                                  required
                                  value={
                                    formData?.vms_maintenance_type !== null
                                      ? formData?.vms_maintenance_type
                                      : ""
                                  }
                                  errorMsg={localization.paymentPicked}
                                  getIdValue={(val) => {
                                    setData({
                                      ...formData,
                                      vms_maintenance_type: val.id,
                                    });
                                  }}
                                  isStarRequired={true}
                                />
                              </div>
                              {formData?.vms_maintenance_type === "Others" && (
                                <div className="col-md-6">
                                  <TextAreaInput
                                    inputValue={
                                      formData?.vms_maintenance_remark !== null
                                        ? formData?.vms_maintenance_remark
                                        : ""
                                    }
                                    className={`${
                                      !formData.vms_maintenance_remark &&
                                      "empty"
                                    } inline-css scrollbar-styling`}
                                    rows={4}
                                    type="text"
                                    label={"Remark"}
                                    required
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    handleChange={(e) =>
                                      setData({
                                        ...formData,
                                        vms_maintenance_remark: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              )}
                            </>
                          )}

                          <DropDownInput
                            data={[
                              { id: "Yes", name: "Yes" },
                              { id: "No", name: "No" },
                            ]}
                            label={"Is CRM being used?"}
                            required
                            value={
                              formData?.crm_check !== null
                                ? formData?.crm_check
                                : ""
                            }
                            errorMsg={localization.paymentPicked}
                            getIdValue={(val) => {
                              setData({
                                ...formData,
                                crm_check: val.id,
                              });
                            }}
                            isStarRequired={true}
                          />
                        </>
                      )}

                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Pre-Alignment for brand promotion."}
                          required
                          value={
                            formData?.alignment_check !== null
                              ? formData?.alignment_check
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              alignment_check: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.alignment_check === "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.alignment_reason !== null
                                ? formData?.alignment_reason
                                : ""
                            }
                            className={`${
                              !formData.alignment_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                alignment_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}

                      {formData?.alignment_check === "Yes" && (
                        <>
                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "Yes", name: "Yes" },
                                { id: "No", name: "No" },
                              ]}
                              label={"Car Display."}
                              required
                              value={
                                formData?.car_check !== null
                                  ? formData?.car_check
                                  : ""
                              }
                              errorMsg={localization.paymentPicked}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  car_check: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.car_check === "No" && (
                            <div className="col-md-12">
                              <TextAreaInput
                                inputValue={
                                  formData?.car_reason !== null
                                    ? formData?.car_reason
                                    : ""
                                }
                                className={`${
                                  !formData.car_reason && "empty"
                                } inline-css scrollbar-styling`}
                                rows={4}
                                type="text"
                                label={localization.reason}
                                required
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(e) =>
                                  setData({
                                    ...formData,
                                    car_reason: e.target.value,
                                  })
                                }
                              />
                            </div>
                          )}

                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "Yes", name: "Yes" },
                                { id: "No", name: "No" },
                              ]}
                              label={"Sampling approval and commercials."}
                              required
                              value={
                                formData?.sampling_check !== null
                                  ? formData?.sampling_check
                                  : ""
                              }
                              errorMsg={localization.paymentPicked}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  sampling_check: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.sampling_check === "No" && (
                            <div className="col-md-12">
                              <TextAreaInput
                                inputValue={
                                  formData?.sampling_reason !== null
                                    ? formData?.sampling_reason
                                    : ""
                                }
                                className={`${
                                  !formData.sampling_reason && "empty"
                                } inline-css scrollbar-styling`}
                                rows={4}
                                type="text"
                                label={localization.reason}
                                required
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(e) =>
                                  setData({
                                    ...formData,
                                    sampling_reason: e.target.value,
                                  })
                                }
                              />
                            </div>
                          )}

                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "Yes", name: "Yes" },
                                { id: "No", name: "No" },
                              ]}
                              label={"Kiosking approval and commercials."}
                              required
                              value={
                                formData?.kiosking_check !== null
                                  ? formData?.kiosking_check
                                  : ""
                              }
                              errorMsg={localization.paymentPicked}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  kiosking_check: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.kiosking_check === "No" && (
                            <div className="col-md-12">
                              <TextAreaInput
                                inputValue={
                                  formData?.kiosking_reason !== null
                                    ? formData?.kiosking_reason
                                    : ""
                                }
                                className={`${
                                  !formData.kiosking_reason && "empty"
                                } inline-css scrollbar-styling`}
                                rows={4}
                                type="text"
                                label={localization.reason}
                                required
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(e) =>
                                  setData({
                                    ...formData,
                                    kiosking_reason: e.target.value,
                                  })
                                }
                              />
                            </div>
                          )}

                          <div className="col-md-6">
                            <DropDownInput
                              data={[
                                { id: "Yes", name: "Yes" },
                                { id: "No", name: "No" },
                              ]}
                              label={
                                "Door to door campaign approval and commercials."
                              }
                              required
                              value={
                                formData?.door_check !== null
                                  ? formData?.door_check
                                  : ""
                              }
                              errorMsg={localization.paymentPicked}
                              getIdValue={(val) => {
                                setData({
                                  ...formData,
                                  door_check: val.id,
                                });
                              }}
                              isStarRequired={true}
                            />
                          </div>
                          {formData?.door_check === "No" && (
                            <div className="col-md-12">
                              <TextAreaInput
                                inputValue={
                                  formData?.door_reason !== null
                                    ? formData?.door_reason
                                    : ""
                                }
                                className={`${
                                  !formData.door_reason && "empty"
                                } inline-css scrollbar-styling`}
                                rows={4}
                                type="text"
                                label={localization.reason}
                                required
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(e) =>
                                  setData({
                                    ...formData,
                                    door_reason: e.target.value,
                                  })
                                }
                              />
                            </div>
                          )}
                        </>
                      )}
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            {
                              id: "More than 15 mins",
                              name: "More than 15 mins",
                            },
                            { id: "15-30 Mins", name: "15-30 Mins" },
                            { id: "30-60 Mins", name: "30-60 Mins" },
                            { id: "1-2 Hours ", name: "1-2 Hours" },
                            { id: "No waiting time", name: "No waiting time" },
                          ]}
                          label={"Waiting time."}
                          required
                          value={
                            formData?.waiting_time !== null
                              ? formData?.waiting_time
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              waiting_time: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={localization.callToHotNegotiationSites}
                          required
                          value={
                            formData?.for_hot_nego_sites !== null
                              ? formData?.for_hot_nego_sites
                              : ""
                          }
                          errorMsg={localization.isRequired}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              for_hot_nego_sites: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.for_hot_nego_sites == "Yes" && (
                        <div
                          className="col-md-12"
                          style={{ marginBlock: "inherit" }}
                        >
                          <span class="red">
                            {localization.fillSitesForCallingForm}
                          </span>

                          {/* <TextAreaInput
                                            inputValue={'Fill the sites for calling form against the site for which call went'}
                                            // className={`${!formData.not_hot_nego_sites_reason && 'empty'} inline-css scrollbar-styling`}
                                            rows={2}
                                            type="text"
                                            label={'Message'}
                                            required
                                            disabled={true}
                                            isStarRequired={true}
                                            errorMsg={localization.isRequired}
                                        /> */}
                        </div>
                      )}
                      {formData?.for_hot_nego_sites == "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.not_hot_nego_sites_reason !== null
                                ? formData?.not_hot_nego_sites_reason
                                : ""
                            }
                            className={`${
                              !formData.not_hot_nego_sites_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                not_hot_nego_sites_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={localization.referralSharedViaWA}
                          required
                          value={
                            formData?.shared_referral_message !== null
                              ? formData?.shared_referral_message
                              : ""
                          }
                          errorMsg={localization.isRequired}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              shared_referral_message: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.shared_referral_message == "Yes" && (
                        <div
                          className="col-md-6"
                          style={{ marginBlock: "inherit" }}
                        >
                          <FileUpload
                            id="referral_shared_image"
                            accept=".png,.jpg,.jpeg"
                            documentUploadUrl={documentUploadUrl}
                            documentUrlData={documentUrlDataPublic}
                            onChange={(val) =>
                              setData({
                                ...formData,
                                referral_shared_image: val,
                              })
                            }
                            prefilledFilename={
                              formData?.referral_shared_image !== null
                                ? formData?.referral_shared_image
                                : ""
                            }
                          >
                            <span className="btn btn-transparent">
                              {localization.uploadReferralAttachment}
                            </span>
                          </FileUpload>
                        </div>
                      )}
                      {formData?.shared_referral_message == "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.not_shared_referral_reason !== null
                                ? formData?.not_shared_referral_reason
                                : ""
                            }
                            className={`${
                              !formData.not_shared_referral_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                not_shared_referral_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={localization.videoTestimonialFromClient}
                          required
                          value={
                            formData?.got_video_testimonial !== null
                              ? formData?.got_video_testimonial
                              : ""
                          }
                          errorMsg={localization.isRequired}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              got_video_testimonial: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData?.got_video_testimonial == "Yes" && (
                        <div
                          className="col-md-12"
                          style={{ marginBlock: "inherit" }}
                        >
                          <span class="red">
                            {localization.shareWithManager}
                          </span>
                        </div>
                      )}
                      {formData?.got_video_testimonial == "No" && (
                        <div className="col-md-6">
                          <TextAreaInput
                            inputValue={
                              formData?.no_video_testimonial_reason !== null
                                ? formData?.no_video_testimonial_reason
                                : ""
                            }
                            className={`${
                              !formData.no_video_testimonial_reason && "empty"
                            } inline-css scrollbar-styling`}
                            rows={4}
                            type="text"
                            label={localization.reason}
                            required
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            handleChange={(e) =>
                              setData({
                                ...formData,
                                no_video_testimonial_reason: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                    </>
                  )}
                  </>
                  )}
                </div>
              </div>
            </div>
          </CardSection>
          {!isLertAssessmentAgenda(formData.subject) &&
          draftData?.site_id != 0 && (
            <>
              <CardSection title={"PCA"} key={10}>
                <Loader isLoading={isLoading} />
                <div className="card-body bg-white" key={20}>
                  <div className="user" key="id1">
                    <div className="form-group row" key="id10">
                      <div className="col-md-6" key="id9">
                        <DropDownInput
                          data={[
                            { id: "<50 L", name: "<50 L" },
                            { id: "50 to 1 Cr", name: "50 to 1 Cr" },
                            { id: "1 Cr to 2 Cr", name: "1 Cr to 2 Cr" },
                            { id: ">2 Cr", name: ">2 Cr" },
                            { id: ">5 Cr", name: ">5 Cr" },
                          ]}
                          label={"Flat Cost."}
                          required
                          value={
                            formData?.flat_cost !== null
                              ? formData?.flat_cost
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              flat_cost: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6" key="id8">
                        <DropDownInput
                          data={[
                            { id: "<2k", name: "<2k" },
                            { id: "2k to 4k", name: "2k to 4k" },
                            { id: "4k to 7k", name: "4k to 7k" },
                            { id: ">7K", name: ">7K" },
                            { id: ">20K", name: ">20K" },
                          ]}
                          label={" Monthly Maintenance fee ."}
                          required
                          value={
                            formData?.monthly_main_fees !== null
                              ? formData?.monthly_main_fees
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              monthly_main_fees: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6" key="id7">
                        <DropDownInput
                          data={[
                            {
                              id: "No Manpower- Self Managed",
                              name: "No Manpower- Self Managed",
                            },
                            {
                              id: "Manpower But at RWA Role",
                              name: "Manpower But at RWA Role",
                            },
                            {
                              id: "Agency But Not Managed by RWA",
                              name: "Agency But Not Managed by RWA",
                            },
                            {
                              id: "Completely Outsourced even Payments etc",
                              name: "Completely Outsourced even Payments etc",
                            },
                            { id: "DLF/Cushman/+", name: "DLF/Cushman/+" },
                          ]}
                          label={"Facility Management."}
                          required
                          value={
                            formData?.facility_management !== null
                              ? formData?.facility_management
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              facility_management: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6" key="id5">
                        <DropDownInput
                          data={[
                            { id: "<100", name: "<100" },
                            { id: "100 to 250", name: "100 to 250" },
                            { id: "250 to 500", name: "250 to 500" },
                            { id: ">500", name: ">500" },
                            { id: ">1000", name: ">1000" },
                          ]}
                          label={"Flat Count."}
                          required
                          value={
                            formData?.flat_count !== null
                              ? formData?.flat_count
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              flat_count: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6" key="id4">
                        <DropDownInput
                          data={[
                            { id: "No good", name: "No good" },
                            { id: "Avg / Good", name: "Avg / Good" },
                            { id: "Medium area", name: "Medium area" },
                            { id: "High end", name: "High end" },
                            { id: "Posh Area", name: "Posh Area" },
                          ]}
                          label={"Locality."}
                          required
                          value={
                            formData?.locality !== null
                              ? formData?.locality
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              locality: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>

                      <div className="col-md-6" key="id2">
                        <DropDownInput
                          data={[
                            { id: "Yes", name: "Yes" },
                            { id: "No", name: "No" },
                          ]}
                          label={"Does upselling opportunity exist?"}
                          required
                          value={
                            formData?.is_upselling_opportunity_exist !== null
                              ? formData?.is_upselling_opportunity_exist
                              : ""
                          }
                          errorMsg={localization.paymentPicked}
                          getIdValue={(val) => {
                            setData({
                              ...formData,
                              is_upselling_opportunity_exist: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>

                      {formData?.is_upselling_opportunity_exist === "Yes" && (
                        <div className="col-md-6" key="id3">
                          <DropDownInput
                            data={siteFilters?.solution_types}
                            label={"select Upselling Opportunity"}
                            required={true}
                            // selectedList={ draftData?.draft_data?.existing_upselling_opportunity !== undefined ? draftData?.draft_data?.existing_upselling_opportunity : '' }
                            getIdValue={(val) => {
                              setUpsellingOpportunityExist(val);
                            }}
                            multipule={true}
                            isStarRequired={true}
                            // errorMsg={localization.paymentPicked}
                          />
                        </div>
                      )}

                      {/*{console.log(upsellingOpportunityExist)}*/}
                      {upsellingOpportunityExist.length > 0 &&
                        upsellingOpportunityExist.map((val, i) => {
                          return (
                            <>
                              {val?.name === "Other" && (
                                <div className="col-md-6" key={val?.id}>
                                  <TextAreaInput
                                    inputValue={
                                      formData?.existing_upselling_opportunity_other !==
                                      null
                                        ? formData?.existing_upselling_opportunity_other
                                        : ""
                                    }
                                    className={`${
                                      !formData.existing_upselling_opportunity_other &&
                                      "empty"
                                    } inline-css scrollbar-styling`}
                                    rows={4}
                                    type="text"
                                    label={"Upselling other opportunity"}
                                    required
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    handleChange={(e) =>
                                      setData({
                                        ...formData,
                                        existing_upselling_opportunity_other:
                                          e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              )}
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </CardSection>
            </>
          )}
        </>
      )}
    </>
  );
};

EditMeetingForm.propTypes = {};

export default EditMeetingForm;
